export const ACCESS_TOKEN = "ACCESS_TOKEN_APP";
export const REFRESH_TOKEN = "REFRESH_TOKEN_APP";
export const USER_LOGGED_IN_KEY = "USER_LOGGED_IN_KEY";
export const LAYOUT_KEY = "LAYOUT_KEY";
export const DEFAULT_LAYOUT = "DEFAULT_LAYOUT_KEY";
